/**
 * Session workflow status and audit action codes (option set values).
 * Backend-neutral integer codes shared across the frontend.
 */

/**
 * Session workflow status codes (option set values)
 */
export const SessionStatus = {
  Draft: 100000000,
  InProgress: 100000001,
  Submitted: 100000002,
  Completed: 100000003,
  Rejected: 100000004,
} as const;

/**
 * Audit action codes (option set values)
 */
export const AuditAction = {
  Started: 100000000,
  Saved: 100000001,
  Submitted: 100000002,
  Approved: 100000003,
  Rejected: 100000004,
  Reassigned: 100000005,
} as const;
